import { render, staticRenderFns } from "./pick-material-modal.vue?vue&type=template&id=a4a98a5a&scoped=true"
import script from "./pick-material-modal.vue?vue&type=script&lang=js"
export * from "./pick-material-modal.vue?vue&type=script&lang=js"
import style0 from "./pick-material-modal.vue?vue&type=style&index=0&id=a4a98a5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a98a5a",
  null
  
)

export default component.exports